<template>
  <v-hover v-slot="{ hover }">
    <div
      class="d-flex align-center justify-space-between"
      :class="getClasses(hover)"
    >
      <div
        class="clickable d-flex align-center pa-3 text-body-2 font-weight-medium flex-grow-1"
        @click="$emit('click')"
      >
        <bubble
          class="mr-3"
          :color="bubbleColor"
          :text-class="bubbleTextClass"
          :label="index"
        />
        <span v-if="!editing" class="criteria-text"
          >{{ description }}
        </span>
        <v-textarea
          v-else
          v-model="description"
          class="pt-0 text-body-2 font-weight-medium"
          rows="1"
          auto-grow
          hide-details
          placeholder="Description"
          :error="showError"
        />
      </div>
      <div v-if="(hover && allowDelete) || editing" class="pr-3">
        <v-btn v-if="editing" icon small>
          <v-icon color="success" @click="onSave">
            check_circle
          </v-icon>
        </v-btn>
        <v-btn icon small @click="$emit('delete')">
          <v-icon color="error">remove_circle</v-icon>
        </v-btn>
      </div>
    </div>
  </v-hover>
</template>

<script>
import Bubble from '@/components/Common/Bubble';
import { ReviewCriteria } from '@/models';
import { CriteriaType } from '@/enums';

export default {
  name: 'ReviewCriteriaListItem',
  components: { Bubble },
  props: {
    value: {
      type: ReviewCriteria,
      required: true,
    },
    index: {
      type: Number,
      default: 1,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    allowDelete: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ showError: false }),
  computed: {
    reviewCriteria: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    descriptionEmpty() {
      return !this.description || this.description.trim() === '';
    },
    description: {
      get: function () {
        return this.reviewCriteria.description;
      },
      set: function (value) {
        const reviewCriteria = this.value;
        this.$set(reviewCriteria, 'description', value);
        this.reviewCriteria = reviewCriteria;
        this.showError = this.descriptionEmpty;
      },
    },
    isInclusionType() {
      return (
        this.reviewCriteria.criteriaType === CriteriaType.INCLUSION
      );
    },
    bubbleColor() {
      if (this.selected) return 'white';
      return this.isInclusionType ? 'green accent-4' : 'red accent-2';
    },
    bubbleTextClass() {
      return this.selected ? 'primary--text' : 'white--text';
    },
  },
  methods: {
    getClasses(hover) {
      return {
        white: !hover && !this.selected,
        'grey lighten-4': hover && !this.selected,
        'primary white--text': this.selected,
      };
    },
    onSave() {
      if (this.descriptionEmpty) {
        this.showError = true;
      } else {
        this.$emit('save');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.criteria-text {
  white-space: pre-line;
}
.clickable {
  cursor: pointer;
}
</style>
